import React from "react";
import "./styles/CheckBox.scss";
import CheckIcon from "../VectorIcons/CheckIcon";

const CheckBox = (props) => {
  const {
    label,
    event,
    isActive,
    index,
    value,
    customEvent,
    GAEventClassNames,
    isDisabled,
    noMargin = false,
  } = props;

  const checkItem = (ev, i) => {
    ev.stopPropagation();
    if (typeof customEvent === "function") return customEvent(value);

    let checkBox = document.getElementsByClassName("check")[0];
    let target = ev.target.closest(".checked");

    if (checkBox) {
      if (!target) {
        checkBox.classList.remove("checked");
      }
    }

    ev.target.closest(".checkBox").classList.toggle("checked");
    event(value);
  };

  return (
    <div
      className={`checkBox
        ${noMargin ? "noMargin" : ""}
        ${isActive ? "checked" : ""}
        ${isDisabled ? "isDisabled" : ""}
      `}
      onClick={(e) => checkItem(e, index)}
    >
      <div className={`check ${GAEventClassNames}`}>
        <div className={`icon ${GAEventClassNames}`}>
          <CheckIcon color="#FFF" className={`${GAEventClassNames}`} />
        </div>
      </div>

      <span className={`label ${GAEventClassNames}`}>{label}</span>
    </div>
  );
};

export default CheckBox;
